import { AddBatchDto } from "@juicy/models/dto";
import { atom } from "recoil";
import { MixerIngredientFormValues } from "../mixer/mixer-flavor/MixeIngredientForm";

export const BatchState = atom<AddBatchDto>({
    key: "BatchState",
    default: {
        vg: 70,
        ingredients: [],
        nicStrength: 0,
        createdAt: new Date(),
    },
});

export const TargetNicStrengthAtom = atom({
    key: "targetNicStrengthAtom",
    default: 6,
});

export const TargetVgAtom = atom({
    key: "targetVgAtom",
    default: 70,
});

export const IngredientFormValuesAtom = atom<MixerIngredientFormValues[]>({
    key: "IngredientFormValuesAtom",
    default: [],
});
